import { PayloadAction } from '@reduxjs/toolkit';

export interface NetworkState {
  isLoading: boolean;
  error?: string;
}

interface NetworkReducers<State> {
  fetchRequest(state: State): void;
  fetchSuccess(state: State): void;
  fetchError(state: State, action: PayloadAction<string>): void;
}

const createNetworkReducers = <
  State extends NetworkState
>(): NetworkReducers<State> => ({
  fetchRequest(state: State): void {
    state.isLoading = true;
  },
  fetchSuccess(state: State): void {
    state.isLoading = false;
  },
  fetchError(state: State, action: PayloadAction<string>): void {
    state.isLoading = false;
    state.error = action.payload;
  }
});

export default createNetworkReducers;
